export default {
	"order.MallOpeningRecordPage": "Mall opening record page",
	"order.PhasesOpened": "Phases opened:",
	"order.StoreOpeningRecordPageBuyTheNextIssueClick": "Store opening record page_Buy the next issue click",
	"order.buyNextIssue": "buy next issue",
	"order.DebitRecord": "Debit record",
	"order.No": "No.",
	"order.Expect": "Expect",
	"order.DebitSuccess": "Debit Success",
	"order.D": "D:",
	"order.PaymentSerialNumber": "Payment serial number:",
	"order.PaymentTime": "Payment time:",
	"order.UnfortunatelyNoMatchingDataWasFound": "Unfortunately, no matching data was found"
}